import { z } from 'zod';
interface IHousehold {
    affiliate: any;
    aptc: any;
    barOptoutIndicator: boolean;
    barOptoutUpdatedBy: any;
    barOptoutUpdatedOn: any;
    birthDate: number;
    consentToCallback: any;
    created: number;
    createdBy: number;
    countyCode: any;
    csr: any;
    dshReferenceNumber: any;
    email: string;
    emailVerified: any;
    eligLead: IEligLead;
    householdCaseId: string;
    familySize: any;
    ffmHouseholdID: any;
    ffmResponse: any;
    firstName: string;
    giHouseholdId: string;
    healthAdvocate: any;
    homePhone: any;
    houseHoldIncome: any;
    id: number;
    lastName: string;
    lastVisited: any;
    leadStatus: string;
    middleName: any;
    mobilePhone: any;
    mobileNumberVerified: boolean;
    nameSuffix: any;
    noticeOptOut: any;
    numberOfApplicants: any;
    outdatedMailingAddress: boolean;
    optInPaperless1095: boolean;
    paperless1095Date: any;
    paperless1095User: any;
    paperlessNotices: boolean;
    phoneNumber: string;
    phoneVerified: any;
    poaPhone: any;
    premium: any;
    preferredContactTime: any;
    prefContactMethod: number;
    prefSpokenLang: any;
    prefWrittenLang: any;
    preferencesReviewDate: any;
    rf3ReceivedDate: any;
    ridpFarsCounter: any;
    ridpDate: number;
    ridpSource: string;
    ridpVerified: string;
    ridpPrimaryCounter: any;
    ridpSecondaryCounter: any;
    servicedBy: any;
    smsVerified: any;
    smsUnsubscribed: any;
    ssn: any;
    ssnNotProvidedReason: any;
    state: any;
    stage: string;
    status: any;
    tenantId: any;
    householdExtension: any;
    emailMe: boolean;
    location: ILocation;
    locationId: any;
    user: IUser;
    updated: number;
    updatedBy: any;
    zipCode: any;
    textMe: boolean;
    phoneNumberOne: any;
    phoneNumberTwo: any;
    prefContactLocation: any;
}

interface IEligLead {
    id: number;
    name: any;
    zipCode: any;
    countyCode: any;
    familySize: number;
    noOfApplicants: number;
    householdIncome: number;
    emailAddress: string;
    phoneNumber: string;
    isOkToCall: string;
    memberData: any;
    aptc: any;
    premium: any;
    csr: any;
    turquoiseLevel: any;
    docVisitFrequency: any;
    noOfPrescriptions: any;
    benefits: any;
    affiliateId: number;
    extAffHouseholdId: any;
    flowId: number;
    clickId: number;
    apiOutput: any;
    overallApiStatus: any;
    giExecutionDuration: any;
    status: any;
    stage: string;
    leadType: string;
    errorCode: number;
    errorMessage: any;
    createdBy: number;
    lastUpdatedBy: number;
    creationTimestamp: number;
    lastUpdateTimestamp: number;
    exchangeFlowType: any;
    appStatus: any;
    appStatusUpdateTimeStamp: any;
    batchProcessed: any;
    createdByAPI: any;
    eventId: any;
    coverageStartDate: any;
    tcpaComplianceURL: any;
    affFileUploadLogId: any;
    eligibilityResult: any;
    eligibilityCalculated: any;
    hasChipMembers: string;
    hasMedicaidChildren: string;
    hasMedicaidMembers: string;
    hasMedicareMembers: string;
    preEligibilityResults: any[];
    tenantId: any;
    dataSharingConsent: any;
    redirectId: any;
    stateSubsidy: any;
}

interface ILocation {
    id: number;
    addOnZip: number;
    address1: string;
    address2: any;
    city: string;
    state: string;
    county: string;
    countycode: any;
    zip: string;
    rdi: any;
    lat: number;
    lon: number;
    created: number;
    updated: number;
}

interface IUser {
    id: number;
    uuid: string;
    userRole: IUserRole[];
    userName: string;
    password: string;
    firstName: string;
    lastName: string;
    title: any;
    securityQuestion1: string;
    securityAnswer1: string;
    securityQuestion2: any;
    securityAnswer2: any;
    securityQuestion3: any;
    securityAnswer3: any;
    pin: any;
    pinexpiration: any;
    email: string;
    secondaryEmail: any;
    phone: string;
    recovery: string;
    communicationPref: any;
    confirmed: number;
    created: number;
    updated: number;
    passwordRecoveryToken: any;
    passwordRecoveryTokenExpiration: any;
    lastLogin: number;
    startDate: any;
    endDate: any;
    isSuperUser: any;
    tenantId: number;
    lockedUntil: any;
    ffmUserId: any;
    userNPN: any;
    retryCount: number;
    secQueRetryCount: number;
    newToHix: boolean;
    emailChanged: boolean;
    passwordLastUpdatedTimeStamp: number;
    sortableColumnNamesSet: string[];
}

interface IUserRole {
    id: number;
    role: IRole;
    created: number;
    updated: number;
    roleFlag: string;
    isActive: string;
}

interface IRole {
    id: number;
    name: string;
    description: string;
    landingPage: string;
    postRegistrationUrl: string;
    created: number;
    updated: number;
    rolePermissions: IRolePermission[];
    label: string;
    privileged: number;
    maxRetryCount: number;
    loginRestricted: number;
    isTenantDefault: string;
    mfaEnabled: string;
    isExclusive: string;
    pwdConstraintsEnabled: string;
    passwordExpiryPeriod: number;
    passwordMinimumLength: number;
    accountIdlePeriod: number;
    externalRef: string;
    isLimitPwdResetOptionsEnabled: string;
}

interface IRolePermission {
    id: number;
    permission: IPermission;
    created: number;
    updated: number;
}

interface IPermission {
    id: number;
    name: string;
    description: string | null;
    isDefault: any;
}

interface IResponseJson {
    QUESTIONS: string[];
    STATUS: string;
    ERROR_MESSAGE: string | null;
}

export interface IResetPasswordResponse {
    statusCode: number;
    statusMessage: string;
    data: {
        householdId: string;
        household: IHousehold;
        responseJson: IResponseJson;
        errorMsg: string | null;
        addNewViewCaseUrl: string | null;
        page_title: string;
    };
}

export interface IResetPasswordValidateResponse {
    STATUS: string;
    OVERRIDE_EMAIL?: boolean;
    QUESTIONS?: string[];
    REMAINING_RETRIES?: number;
    EMAIL_ID?: string;
    ERROR_MESSAGE?: string;
}

export interface IResetPasswordSubmitEmailResponse {
    STATUS: string;
    EMAIL_ID: string;
    ERROR_MESSAGE?: string;
}

export interface IResetPasswordSubmitEmailRequest {
    emailType: string;
    email?: string;
    reason?: string;
}

export const COMPONENT_TYPES = {
    INPUT: 'input',
    MASKED: 'masked',
    RADIO: 'radio',
    DATE: 'date',
} as const;

export type ComponentType = (typeof COMPONENT_TYPES)[keyof typeof COMPONENT_TYPES];

export type BaseFieldConfig = {
    labelId: string;
    getValidation: (intl: any) => z.ZodTypeAny;
    componentType: ComponentType;
    className?: string;
    placeholder?: string;
};

export type InputFieldConfig = BaseFieldConfig & {
    componentType: typeof COMPONENT_TYPES.INPUT;
};

export type MaskedFieldConfig = BaseFieldConfig & {
    componentType: typeof COMPONENT_TYPES.MASKED;
    mask: (string | RegExp)[];
};

export type RadioFieldConfig = BaseFieldConfig & {
    componentType: typeof COMPONENT_TYPES.RADIO;
    options: { value: string; text: string }[];
};

export type DateFieldConfig = BaseFieldConfig & {
    componentType: typeof COMPONENT_TYPES.DATE;
};

export type FieldConfig = InputFieldConfig | MaskedFieldConfig | RadioFieldConfig | DateFieldConfig;

export interface questionsRequest {
    firstName?: string;
    lastName?: string;
    zipCode?: string;
    county?: string;
    sizeOfHousehold?: string;
    phoneNo?: string;
    ssn?: string;
    dob?: string;
    gender?: string;
}
